<div class="relative" data-testid="assistant-launcher-button-root">
  @if (latestPreview(); as preview) {
    <lib-assistant-message-preview
      class="absolute bottom-full left-0 mb-3"
      [senderFirstName]="preview.senderFirstName"
      [senderLastName]="preview.senderLastName"
      [text]="preview.text"
      [hasVideo]="!!preview.video"
      [videoThumbnailUrl]="preview.video?.thumbnailUrl"
      (previewClick)="onButtonClick()"
      (closeClick)="onPreviewCloseClick()"
    ></lib-assistant-message-preview>
  }

  <button
    type="button"
    class="relative flex size-14 items-center justify-center"
    data-testid="assistant-launcher-button"
    (click)="onButtonClick()"
  >
    <svg-icon key="px-48-assistant" class="!h-12 !w-12"></svg-icon>

    @if (unreadCount() > 0) {
      <span
        class="typo-h6-semibold absolute right-[-8px] top-[-6px] flex h-[18px] min-w-[18px] items-center justify-center rounded-full bg-states-red px-1 text-text-white"
        data-testid="assistant-launcher-unread-counter"
        >{{ unreadCount() }}</span
      >
    }
  </button>

  @if (isInsideTrialPeriod() && siteId()) {
    <lib-assistant-trial-badge
      class="absolute -bottom-10 left-1/2 -translate-x-1/2"
      [siteId]="siteId()!"
      variant="caption"
    ></lib-assistant-trial-badge>
  }
</div>
